import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { get, type Catalog, type Connection, type Migration, type Run, type WorkspaceDetail } from "../../lib/api";

export function useWorkspaceId(): string {
  return (useParams({ strict: false }) as { workspaceId: string }).workspaceId;
}

export function useWorkspace(id: string) {
  return useQuery({ queryKey: ["ws", id], queryFn: () => get<WorkspaceDetail>(`/api/workspaces/${id}`) });
}

export function useCatalog() {
  return useQuery({ queryKey: ["catalog"], queryFn: () => get<Catalog>("/api/catalog"), staleTime: Infinity });
}

export function useConnections(ws: string) {
  return useQuery({ queryKey: ["connections", ws], queryFn: async () => (await get<{ connections: Connection[] }>(`/api/workspaces/${ws}/connections`)).connections });
}

export interface FileInfo {
  id: string;
  name: string;
  size: number;
  status: string;
  sniff: { headers: string[]; delimiter: string; encoding: string; sampleRows: Record<string, string>[] } | null;
  createdAt: number;
}

export function useFiles(ws: string) {
  return useQuery({ queryKey: ["files", ws], queryFn: async () => (await get<{ files: FileInfo[] }>(`/api/workspaces/${ws}/files`)).files });
}

export function useMigrations(ws: string) {
  return useQuery({ queryKey: ["migrations", ws], queryFn: async () => (await get<{ migrations: Migration[] }>(`/api/workspaces/${ws}/migrations`)).migrations });
}

export function useRuns(ws: string) {
  return useQuery({ queryKey: ["runs", ws], queryFn: async () => (await get<{ runs: Run[] }>(`/api/workspaces/${ws}/runs`)).runs });
}

export const can = (perms: string[] | undefined, p: string) => Boolean(perms?.includes(p));
